import axios from "../../config/axiosConfig";
import {
  SALES_INTREST_CALCULATION_REPORT_REQUEST,
  SALES_INTREST_CALCULATION_REPORT_SUCCESS,
  SALES_INTREST_CALCULATION_REPORT_FAILURE
} from "../types/sales-intrest-calculation-report-types";

export const getSalesInterestCalculation = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_INTREST_CALCULATION_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getSalesIntrestCalculationReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get('/outstanding-report/getSalesIntrestCalculationReport', {
        params: requestParams,
      }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_INTREST_CALCULATION_REPORT_SUCCESS, payload: response.data });
        }  
      }).catch((error) => {
        console.error("Error fetching Sales Outstanding Report:", error);
        dispatch({ type: SALES_INTREST_CALCULATION_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Outstanding Report:", error);
      dispatch({ type: SALES_INTREST_CALCULATION_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearSalesInterestCalculation = () => {
  return async (dispatch) => {
    dispatch({ type: SALES_INTREST_CALCULATION_REPORT_SUCCESS, payload: {} });
  }
}
